export enum SenderTypeE {
  AGENT = 'agent',
  CONTACT = 'contact',
  FLOW = 'flow',
  BOT = 'bot',
  AI_AGENT = 'ai-agent',
}
